
function CompaignHeader({ campaign, brand_color }) {


  return (
    <div className="mb-8">
      <img
        src={campaign.logo}
        alt={campaign?.name}
        className="h-24 w-auto "
      />
      <h1 style={{
        // color: brand_color
      }} className="text-4xl font-bold mt-6 text-black">{campaign?.name}</h1>
    </div>
  );
}

export default CompaignHeader;
